import { Component, Prop, h } from '@stencil/core';
import { store } from '@stencil/redux';
import { Unsubscribe } from 'redux';
import { RootState } from '../../redux/reducers';
import { PaymentConfig, PaymentMethod, RtrError, SplitOption } from '../../redux/types';
import { ComponentView, Price } from '../../types/types';
import { CodeStatus, PaymentCustomer } from './utils/types';
import { initPayment } from '../../redux/actions';

@Component({
  tag: 'rtr-payment',
  shadow: true,
})
export class RtrPayment {
  @Prop() orderReference!: string;
  @Prop() amountToPay!: number;
  @Prop() paymentCustomer!: PaymentCustomer;
  /* props above should be given from outside, as there is more that one source regarding of place of payment component */
  @Prop() depositPrice: Price;
  @Prop() view: ComponentView = ComponentView.Checkout;
  @Prop() setParentWaiting: (value: boolean) => void;
  @Prop() setMethodValidated: (value: boolean) => void;

  @Prop({ mutable: true }) paymentConfig: PaymentConfig;
  @Prop({ mutable: true }) selectedSplitOption: SplitOption;
  @Prop({ mutable: true }) paymentMethod: PaymentMethod;
  @Prop({ mutable: true }) secondaryPaymentMethod: PaymentMethod;
  @Prop({ mutable: true }) billingStepValues: any;
  @Prop({ mutable: true }) prepay: CodeStatus;
  @Prop({ mutable: true }) paymentFailed: boolean;
  @Prop({ mutable: true }) errors: RtrError[] = [];
  @Prop({ mutable: true }) isOrder: boolean;

  initPayment!: typeof initPayment;
  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        paymentConfig: state.payment,
        selectedSplitOption: state.app.paymentSplitOption,
        paymentMethod: state.app.paymentMethod,
        secondaryPaymentMethod: state.app.secondaryPaymentMethod,
        billingStepValues: state.app.billingStepValues,
        prepay: state.app.prepayStatus,
        paymentFailed: state.app.paymentFailed,
        errors: state.errors,
        isOrder: !!state.orderDetails?.id,
      };
    });

    store.mapDispatchToProps(this, {
      initPayment,
    });
  }

  componentDidLoad() {
    if (!this.paymentConfig) {
      this.initPayment({ orderReference: this.orderReference });
    }
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  render() {
    if (!this.orderReference || !this.paymentConfig || !this.paymentCustomer) {
      return null;
    }

    return (
      <rtr-payment-engine
        orderReference={this.orderReference}
        paymentConfig={this.paymentConfig}
        giftCard={this.paymentConfig?.giftCard}
        selectedSplitOption={this.selectedSplitOption}
        paymentMethod={this.paymentMethod}
        secondaryPaymentMethod={this.secondaryPaymentMethod}
        depositPrice={this.depositPrice}
        paymentCustomer={this.paymentCustomer}
        amountToPay={this.amountToPay}
        prepay={this.prepay}
        errors={this.errors}
        setParentWaiting={this.setParentWaiting}
        paymentFailed={this.paymentFailed}
        view={this.view}
        isOrder={this.isOrder}
        setMethodValidated={this.setMethodValidated}
      />
    );
  }
}
